import React from "react";
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from "react-router";
import './TopBannerSlider.scss'
import { setLoginNew } from '../../../store/LoginNew/loginNew.slice'


const TopBannerOne = ({ inPlaySlidingBanners, }) => {
  const history = useHistory();
  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)

  return (
    <div className='banner-one__item' >
      <div className="banner-one__item_img"
        style={{ backgroundImage: `url(${inPlaySlidingBanners[0].image})`, backgroundColor: inPlaySlidingBanners[0].backgroundColour }}
        onClick={() => {
          history.push(inPlaySlidingBanners[0].redirect)
          // if(auth) {
          //   history.push(inPlaySlidingBanners[0].redirect)
          // } else {
          //   dispatch(setLoginNew(true))
          // }
        }}/>
    </div>
  );
}


export default TopBannerOne
